import { render, staticRenderFns } from "./shopLabels.vue?vue&type=template&id=22c811d7&"
import script from "./shopLabels.vue?vue&type=script&lang=js&"
export * from "./shopLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports